import React, { useEffect, useState, useCallback, useRef } from "react";
import { adminApi } from "../../api";
import SystemHealthPage from "./SystemHealthPage";

interface ServiceStatus {
  name: string;
  url: string;
  ip_address?: string;
  status: string;
  tag?: string;
  gpu_enabled?: boolean;
  http_code?: number | null;
  latency_ms?: number | null;
  last_checked: string;
  error?: string | null;
}

interface HealthCheckResponse {
  services: ServiceStatus[];
}

const POLL_INTERVAL_MS = 10_000;

const SystemHealthContainer: React.FC = () => {
  const [services, setServices] = useState<ServiceStatus[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const fetchHealth = useCallback(async () => {
    try {
      const res = await adminApi.get<HealthCheckResponse>(
        "/admin/health-check"
      );
      setServices(res.data.services);
      setError(null);
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : "Failed to fetch health status";
      setError(message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchHealth();
    intervalRef.current = setInterval(fetchHealth, POLL_INTERVAL_MS);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [fetchHealth]);

  const handleRefresh = () => {
    setLoading(true);
    fetchHealth();
  };

  return (
    <SystemHealthPage
      services={services}
      loading={loading}
      error={error}
      pollInterval={POLL_INTERVAL_MS}
      onRefresh={handleRefresh}
    />
  );
};

export default SystemHealthContainer;
